module.exports = __webpack_public_path__ + "static/media/facebook.c52f903e.svg";